import { createFileRoute, Outlet } from "@tanstack/react-router";
import OptionCatalogStateProvider from "lib/components/options/catalog/utils/optionCatalogStateProvider";

function OptionCatalogLayout() {
  return (
    <OptionCatalogStateProvider>
      <Outlet />
    </OptionCatalogStateProvider>
  );
}

export const Route = createFileRoute("/builders/$builder_id/options")({
  component: OptionCatalogLayout,
});
